export default "__VITE_ASSET__B6meV4UI__"